(function ($) {

    $('.career-carousel').flickity({
        cellSelector: '.cell-career-carousel',
        cellAlign: 'left',
        draggable: false,
        freeScroll: false,
        pageDots: false,
        wrapAround: true,
        prevNextButtons: false,
        autoPlay: 1500,
        pauseAutoPlayOnHover: false,
        fade: true,
    });

    $('.button-career-filter').on('click', function() {
        $division = this.getAttribute('data-division');
        $selected = '[data-division='+$division+']';
        if ($division!='all') {
            $('.position').addClass('hide');
            $('.'+$division).removeClass('hide');
        } else {
            $('.position').removeClass('hide');
        }
        $('.button-career-filter').removeClass('filter-active');
        $($selected).addClass('filter-active');
    });



})(jQuery);
